// extracted by mini-css-extract-plugin
export default {"rectangle_small":"Avatar_rectangle_small__YqxzP","circle_small":"Avatar_circle_small__A9A49","Image_No_Distortion__container":"Avatar_Image_No_Distortion__container__fh-Sn"};